import Menu, { MenuParams } from './menu';
import MenuButton, { MenuButtonParams } from './menuButton';


export interface LinedButtonsMenuParams extends MenuParams { }


export default class LinedButtonsMenu extends Menu implements LinedButtonsMenuParams {
  /* buttons in a straight line */
  createButtons(): void {
    const { x, y, width, height, itemWidth, buttonsParameters, ignoreCamera } = this;
    this.buttons = buttonsParameters
      .map((itemParams, row) => new MenuButton({
        ...itemParams,
        menu: this,
        ignoreCamera,
        row,
        x: x + (itemWidth * row) - width / 2,
        y: y - height / 2,
        width: itemWidth,
        height: height
      } as MenuButtonParams))
      ;
  }
}
